import { TableColumnsType, Tooltip } from "antd";
import moment from "moment";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusOutlined,
} from "@ant-design/icons";

import { ResponseOfferSingleTableType } from "../../models";

export const offerResponeSingleColumns: TableColumnsType<ResponseOfferSingleTableType> =
  [
    {
      title: "OSIGURAVAJUĆE DRUŠTVO",
      dataIndex: ["insurance", "name"],
    },
    {
      title: <div className="text-center">Ocjena</div>,
      width: 130,
      render: (record) => (
        <div className="text-center">
          {record.correct === true && (
            <Tooltip title="Ispravna">
              <CheckCircleOutlined className="text-estimate-success text-base" />
            </Tooltip>
          )}
          {record.correct === false && (
            <Tooltip
              title={
                record.incorrectReason
                  ? `Neispravna: ${record.incorrectReason}`
                  : "Neispravna"
              }
            >
              <CloseCircleOutlined className="text-estimate-fail text-base" />
            </Tooltip>
          )}
          {record.correct == null && (
            <Tooltip title="Nije ocijenjena">
              <MinusOutlined className="text-base opacity-40" />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: "Datum zadnje izmjene",
      dataIndex: "updatedAt",
      responsive: ["md"],
      width: 190,
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
      sorter: (a, b) => moment(a.updatedAt).diff(moment(b.updatedAt)),
    },
  ];
